import React from 'react';

import LazyLoadedImage from 'common/LazyLoadedImage';
import type { Integration } from 'common/subdomain/admin/AdminQueue/GettingStarted/constants';
import Button from 'common/uiV3/Button';
import HStack from 'common/uiV3/HStack';
import Switch from 'common/uiV3/Switch';
import { IntegrationButtonDefaultProps } from './constant';

type Props = {
  integration: Integration;
  enabled: boolean;
  openIntegrationModal: () => void;
  loading: boolean;
};

const AdminIntegrationToggleButton = ({
  integration,
  enabled,
  openIntegrationModal,
  loading,
}: Props) => {
  const toggleHint = `${integration.label} is currently ${
    enabled ? 'enabled' : 'disabled'
  } as an Autopilot data source. Open a modal to adjust settings.`;

  return (
    <Button
      {...IntegrationButtonDefaultProps}
      isLoading={loading}
      onClick={openIntegrationModal}
      aria-label={toggleHint}>
      <HStack className="flex-1 items-center gap-3 min-w-0">
        <LazyLoadedImage className="w-8 h-auto" src={integration.icon} alt="" />
        <p className="truncate">{integration.label}</p>
      </HStack>
      <Switch tabIndex={-1} checked={enabled} size="small" className="pointer-events-none" />
    </Button>
  );
};

export default AdminIntegrationToggleButton;
